var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-section py-5"},[_c('section',{staticClass:"container"},[_c('h1',{staticClass:"text-center"},[_vm._v("Category name: "+_vm._s(_vm.context.term ? _vm.context.term.name : ''))])])])}
var staticRenderFns = []

export { render, staticRenderFns }